import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';
import moment from "moment";



const httpClient = axios.create();
class ReferralCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    componentDidMount() {
    }
    componentWillUnmount() {
    }



    render() {

        return (

            <div class="mid-contant">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="head1">
                                <h2>RO/RMU/Distributor Referral Code</h2>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="registerbox">
                                <div class="row mb-3">
                                    <div class="col-12 col-lg-7">
                                        <form action="ro-basic.html">
                                            <div class="row">
                                                <div class="col-12 col-lg-7">
                                                    <div class="form-floating">
                                                        <input type="text" class="form-control" id="code" placeholder="Enter" value=""/>
                                                            <label for="code">Enter referral code</label>
                                                    </div>
                                                </div>


                                                <div class="col-12">
                                                    <div class="roreferraldetails">
                                                        <p>RO Name: Nishant Kumar</p>
                                                        <p>RO Code: 12345678901</p>
                                                        <p>Address: 8th Floor, c/o COOFFIZ, Magnum Towers, Golf Course Extension, Sector 58, Gurugram, 122011, Haryana, India</p>
                                                    </div>
                                                </div>

                                                <div class="col-12">
                                                    <button type="submit" class="btn btn-primary" id="">Submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div class="col-12 col-lg-5">
                                        <div class="rightbanner"><img src="images/referral.png" alt="Oxigen" class="img-fluid"/></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone
});

export default connect(mapStateToProps, null)(ReferralCode);
